import { device } from '@src/common/breakpoints';
import { LayoutColors } from '@src/core/theme';
import { BodyLargeBold, BodySmall, BodyRegularSemiBold, BodySmallMedium } from '@src/fonts/typography/Typography';
import styled, { css } from 'styled-components';

export const DateInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const CardPayment = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CardPaymentTitle = styled.h4`
  ${BodyLargeBold};
  color: ${LayoutColors.justBlue};
`;

export const Brands = styled.div`
  display: flex;
  margin-top: 4px;
  img {
    width: 25px;
    margin-right: 4px;
  }
`;

export const Label = styled.label`
  ${BodySmall};
`;

export const DateInputs = styled.div`
  display: flex;
  align-items: baseline;
  gap: 0 15px;
`;

export const SingleInput = styled.div`
  width: 100%;
  color: ${LayoutColors.blackDark};
  ${BodySmall};
`;

export const TwoInputs = styled.div`
  display: flex;
  align-items: flex-start;
  flex-flow: column;
  gap: 16px;

  ${device.smallTablet} {
    flex-flow: row;
    gap: 0 15px;
  }
`;

export const CompletePurchase = styled.button`
  width: 100%;
  background-color: ${LayoutColors.successDark};
  height: 44px;
  ${BodyRegularSemiBold};
  border-radius: 4px;
  padding: 8px;
  margin-top: 16px;
  color: ${LayoutColors.whiteLight};
  border-style: none;
  cursor: pointer;
`;

export const InputSelectStyle = css`
  width: 100%;
  margin-bottom: 4px;
  border-radius: 4px;
  background-color: ${LayoutColors.whiteLight};
  border: 1px solid ${LayoutColors.blackLight};
  padding: 12px;
  height: 46px;
`;

export const Select = styled.select`
  ${InputSelectStyle};

  -webkit-appearance: none;
  -moz-appearance: none;
  background: white;
  background-image: url("data:image/svg+xml;utf8,<svg fill='gray' height='30' viewBox='0 0 24 24' width='40' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: 6px;
  cursor: pointer;

  option {
    background-color: white !important;
    color: ${LayoutColors.blackMain} !important;
  }
`;

export const PaymentSoftdescriptor = styled.span`
  width: 100%;
  ${BodySmallMedium};
  color: ${LayoutColors.justBlue};
  background-color: ${LayoutColors.justBlueLigth};
  padding: 8px;
  border-radius: 4px;
`;
